import React from "react";
import CustomReportStyle from "./style";
import DevelopmentImg from "../../../../assets/Icons/development-img.png";
import { Button, Row } from "antd";

const CustomeReport = () => {

  return (
    <>
      <CustomReportStyle>
        <div className="user-title-container users-menu-filter-container">
          <h1 className="user-menu-title">Custom Reports</h1>
        </div>

        <Row className="yet-designed-pages">
          <div className="yet-designed-pages">
            <p className="developement-content">Save time by creating and automatically exporting custom reports</p>
            <span className="developement-span-content">Dive deep into your analytics with customizable reports and adapt your data to your exact needs. Fine-tune your reports with different rules and output elements, and then schedule them to be sent directly to your inbox.</span>
            <Button className="developement-add-button">Upgrade now</Button>
          </div>

          <img
            src={DevelopmentImg}
            alt={DevelopmentImg}
            className="yet-designed-pages-image"
          />
        </Row>
      </CustomReportStyle>
    </>
  );
};

export default CustomeReport;
